function WidgetTitle({text, style = {}}) {
  return <label className="co-text" style={{ margin: '10px 0', letterSpacing: '2px', fontWeight: 'bold', fontSize: '38px' , ...style}}>{text  || ''}</label>
}

export default WidgetTitle;